// LocalStorage backed mock persistence for budgets.
const KEY = "reformas_budgets_v1";

export function loadBudgets() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

export function saveBudgets(budgets) {
  localStorage.setItem(KEY, JSON.stringify(budgets));
}

export function upsertBudget(budget) {
  const all = loadBudgets();
  const idx = all.findIndex((b) => b.id === budget.id);
  if (idx >= 0) {
    all[idx] = budget;
  } else {
    all.unshift(budget);
  }
  saveBudgets(all);
  return budget;
}

export function deleteBudget(id) {
  const all = loadBudgets().filter((b) => b.id !== id);
  saveBudgets(all);
}

export function getBudget(id) {
  return loadBudgets().find((b) => b.id === id) || null;
}

export function newBudgetId() {
  return `B-${Date.now().toString(36).toUpperCase()}`;
}

export function calcTotals(partidas, ivaRate = 0.21) {
  const base = (partidas || []).reduce(
    (acc, p) => acc + (Number(p.cantidad) || 0) * (Number(p.precio_unitario) || 0),
    0
  );
  const iva = base * ivaRate;
  return {
    base: round2(base),
    iva: round2(iva),
    total: round2(base + iva),
  };
}

export function round2(n) {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

export function fmtEUR(n) {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  }).format(Number(n) || 0);
}

export function fmtDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}
